export const formatCardCreateDate = (date: string | null) => {
  if (!date) {
    return 'Invalid date';
  }

  const dateObj = new Date(date);

  if (isNaN(dateObj.getTime())) {
    return 'Invalid date';
  }

  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  const year = String(dateObj.getFullYear()).slice(-2);
  return `${month}.${day}.${year}`;
};
